
import React from 'react';
import { TopMenuBar } from '@/components/TopMenuBar';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { Home, ArrowLeft, Search, HelpCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  React.useEffect(() => {
    document.title = 'Dialgia Group - Page Not Found | 404 Error';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <TopMenuBar />
      <Navigation />
      
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-2xl mx-auto text-center">
          {/* Large 404 */}
          <div className="mb-8">
            <h1 className="text-[120px] md:text-[200px] font-bold text-gray-200 leading-none">404</h1>
          </div>
          
          {/* Error Message */}
          <div className="mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Oops! Page Not Found
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              The page you're looking for doesn't exist or has been moved. 
              Don't worry, it happens to the best of us!
            </p>
          </div>
          
          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link to="/">
              <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white hover:text-white">
                <Home className="mr-2 h-5 w-5 text-white" />
                Go to Homepage
              </Button>
            </Link>
            <Button size="lg" variant="outline" onClick={() => window.history.back()}>
              <ArrowLeft className="mr-2 h-5 w-5" />
              Go Back
            </Button>
          </div>
          
          {/* Help Links */}
          <div className="border-t border-gray-200 pt-8">
            <p className="text-gray-500 mb-4">Need help finding what you're looking for?</p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/contact" className="text-blue-600 hover:text-blue-700 flex items-center gap-1">
                <HelpCircle className="h-4 w-4" />
                Contact Support
              </Link>
              <Link to="/faq" className="text-blue-600 hover:text-blue-700 flex items-center gap-1">
                <Search className="h-4 w-4" />
                Search FAQs
              </Link>
              <Link to="/products" className="text-blue-600 hover:text-blue-700">
                Browse Products
              </Link>
              <Link to="/about" className="text-blue-600 hover:text-blue-700">
                About Us
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default NotFound;
